import React from 'react';
import { BookOpen, Users, Star, Heart } from 'lucide-react';
import { Countdown } from './Countdown';
const IMG_RECETARIO = 'https://cdn.magicpatterns.com/uploads/cCEEGmoLnawrgKmm7fpLEG/PORTADA_RECETARIO_BUDINES.jpg';
const IMG_BONO_1 = 'https://cdn.magicpatterns.com/uploads/juiUaShqgxjJgCLuuuEQU7/BONO_1_EMPRENDER.jpg';
const IMG_BONO_2 = 'https://cdn.magicpatterns.com/uploads/dtj7Ncvbp3EfJJApgyx8ef/BONO_2_CONSERVACION.jpg';
const IMG_BONO_3 = 'https://cdn.magicpatterns.com/uploads/oDpiJdc3skG91BUSiiAEfJ/BONO_3_SUSTITUCIONES.jpg';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* 1. Barra fija superior roja */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 shadow-md" data-id="element-13">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium" data-id="element-14">
          <span data-id="element-15">Esta oferta vence pronto</span>
          <Countdown variant="red" data-id="element-16" />
        </div>
      </div>

      {/* 2. Hero Section */}
      <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-[#FAF6F0] to-white overflow-hidden" data-id="element-17">
        <div className="max-w-5xl mx-auto text-center" data-id="element-18">
          <h1 className="text-4xl md:text-6xl font-extrabold text-violet-900 tracking-tight mb-6" data-id="element-19">
            Mega-Pack 20 Budines{' '}
            <span className="text-violet-500" data-id="element-20">Irresistibles</span>
          </h1>
          <p className="text-xl md:text-2xl text-stone-700 max-w-3xl mx-auto mb-12" data-id="element-21">
            El recetario completo que te enseña a hacer budines esponjosos,
            húmedos y perfectos en casa, sin fallar nunca y con la posibilidad
            de convertirlo en un ingreso extra.
          </p>

          {/* Pack Composite Image (Hero version) */}
          <div className="relative h-[340px] md:h-[460px] max-w-3xl mx-auto mb-8 cursor-pointer group" onClick={scrollToOffer} data-id="element-22">
            {/* Multi-layer glow for depth */}
            <div className="absolute inset-0 bg-violet-400/50 blur-[120px] rounded-full animate-pulse" data-id="element-23" />
            <div className="absolute inset-x-1/4 inset-y-1/4 bg-amber-200/40 blur-[80px] rounded-full" data-id="element-24" />
            <div className="absolute left-[40%] top-[10%] w-[20%] h-[60%] bg-white/60 blur-[60px] rounded-full" data-id="element-25" />

            {/* Sparkles */}
            <div className="absolute top-[8%] left-[20%] text-2xl md:text-3xl animate-pulse" data-id="element-26">
              ✨
            </div>
            <div className="absolute top-[15%] right-[15%] text-xl md:text-2xl animate-pulse" style={{
            animationDelay: '0.5s'
          }} data-id="element-27">
              ✨
            </div>
            <div className="absolute bottom-[10%] left-[35%] text-lg md:text-xl animate-pulse" style={{
            animationDelay: '1s'
          }} data-id="element-28">
              ✨
            </div>

            {/* Bono 1 - Emprendé */}
            <img src={IMG_BONO_1} alt="Bono 1 - Emprendé" className="absolute w-[24%] md:w-[26%] left-[8%] top-[22%] -rotate-[10deg] rounded-xl shadow-[0_20px_50px_rgba(91,33,182,0.4)] ring-4 ring-white transition-all duration-500 group-hover:-translate-x-6 group-hover:-rotate-[14deg] group-hover:scale-105 object-cover aspect-[3/4]" data-id="element-29" />
            {/* Bono 2 - Conservá */}
            <img src={IMG_BONO_2} alt="Bono 2 - Conservá" className="absolute w-[24%] md:w-[26%] right-[28%] top-[16%] rotate-[5deg] rounded-xl shadow-[0_20px_50px_rgba(91,33,182,0.4)] ring-4 ring-white transition-all duration-500 group-hover:translate-x-2 group-hover:rotate-[8deg] group-hover:scale-105 object-cover aspect-[3/4]" data-id="element-30" />
            {/* Bono 3 - Sustituí */}
            <img src={IMG_BONO_3} alt="Bono 3 - Sustituí" className="absolute w-[24%] md:w-[26%] right-[3%] top-[26%] rotate-[10deg] rounded-xl shadow-[0_20px_50px_rgba(91,33,182,0.4)] ring-4 ring-white transition-all duration-500 group-hover:translate-x-8 group-hover:rotate-[14deg] group-hover:scale-105 object-cover aspect-[3/4]" data-id="element-31" />
            {/* Main Product */}
            <img src={IMG_RECETARIO} alt="Recetario Principal" className="absolute w-[42%] md:w-[40%] left-[50%] -translate-x-[50%] top-[2%] z-30 rounded-2xl shadow-[0_30px_80px_rgba(0,0,0,0.4)] ring-4 ring-white transition-all duration-500 group-hover:scale-110 object-cover aspect-[3/4]" data-id="element-32" />

            {/* Badge "BESTSELLER" */}
            <div className="absolute top-0 right-[2%] md:right-[8%] z-40 bg-yellow-400 text-violet-900 font-extrabold text-xs md:text-sm px-3 py-1.5 rounded-full shadow-lg rotate-12 border-2 border-white" data-id="element-33">
              ⭐ BESTSELLER
            </div>
          </div>

          <p className="text-lg font-medium text-violet-800 mb-8" data-id="element-34">
            1 Recetario + 3 Bonos Gratis
          </p>

          <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_30px_rgba(34,197,94,0.5)] hover:shadow-[0_0_40px_rgba(34,197,94,0.7)] transition-all animate-pulse" data-id="element-35">
            SÍ, QUIERO EL MEGA-PACK
          </button>
        </div>
      </section>

      {/* 3. Social Proof */}
      <section className="bg-white border-b border-stone-200" data-id="element-36">
        <div className="bg-violet-50 py-3 text-center border-b border-violet-100" data-id="element-37">
          <div className="flex items-center justify-center gap-3" data-id="element-38">
            <div className="flex -space-x-3" data-id="element-39">
              {[1, 2, 3, 4].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-8 h-8 rounded-full border-2 border-white" data-id="element-40" />)}
            </div>
            <span className="text-violet-900 font-medium text-sm md:text-base" data-id="element-41">
              Más de 2.847 personas ya lo están usando
            </span>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-42">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-43">
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#FAF6F0] border border-stone-200" data-id="element-44">
              <div className="bg-violet-100 p-3 rounded-full text-violet-600" data-id="element-45">
                <BookOpen className="w-6 h-6" data-id="element-46" />
              </div>
              <div data-id="element-47">
                <p className="font-bold text-xl text-violet-900" data-id="element-48">20+</p>
                <p className="text-sm text-stone-600" data-id="element-49">Recetas probadas</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-violet-50 border border-violet-100" data-id="element-50">
              <div className="bg-violet-200 p-3 rounded-full text-violet-700" data-id="element-51">
                <Users className="w-6 h-6" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <p className="font-bold text-xl text-violet-900" data-id="element-54">2.8k+</p>
                <p className="text-sm text-stone-600" data-id="element-55">Personas activas</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-green-50 border border-green-100" data-id="element-56">
              <div className="bg-green-100 p-3 rounded-full text-green-600" data-id="element-57">
                <Star className="w-6 h-6 fill-current" data-id="element-58" />
              </div>
              <div data-id="element-59">
                <p className="font-bold text-xl text-violet-900" data-id="element-60">4.9/5</p>
                <p className="text-sm text-stone-600" data-id="element-61">Valoración media</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-red-50 border border-red-100" data-id="element-62">
              <div className="bg-red-100 p-3 rounded-full text-red-600" data-id="element-63">
                <Heart className="w-6 h-6 fill-current" data-id="element-64" />
              </div>
              <div data-id="element-65">
                <p className="font-bold text-xl text-violet-900" data-id="element-66">100%</p>
                <p className="text-sm text-stone-600" data-id="element-67">Satisfacción</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}